import { render, staticRenderFns } from "./modalAlertaExame.vue?vue&type=template&id=712e6776&"
import script from "./modalAlertaExame.vue?vue&type=script&lang=js&"
export * from "./modalAlertaExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports